import { createAction } from '@gef-ui/utils/fsaActions';
import identity from "ramda/es/identity";
import map from "ramda/es/map";
import keyMirror from "ramda-extension/es/keyMirror";
import { merge } from 'rxjs';
import { map as rxMap } from 'rxjs/operators';
import { affectedFieldsTypes } from '../../constants';
export const actionNames = keyMirror({
    UPDATE_FORM_DATA: null,
    UPDATE_VALIDATION_RESULT: null,
    UPDATE_ASYNC_VALIDATION_STATE: null
});
export const validationRunner = keyMirror({
    ALL: null,
    SYNC: null,
    ASYNC: null
});
const createMetaRunner = (initMeta)=>(_, runner = validationRunner.SYNC, meta = {})=>({
            ...initMeta,
            runner,
            ...meta
        });
export const updateFormData = createAction(actionNames.UPDATE_FORM_DATA, identity, ()=>({
        affectedFields: affectedFieldsTypes.ALL
    }));
export const updateValidationResult = createAction(actionNames.UPDATE_VALIDATION_RESULT, identity, createMetaRunner({
    affectedFields: affectedFieldsTypes.BY_RECORD
}));
export const updateValidationResultRapid = createAction(actionNames.UPDATE_VALIDATION_RESULT, identity, createMetaRunner({
    affectedFields: affectedFieldsTypes.BY_RECORD,
    rapid: true
}));
export const updateValidationResultMultiple = createAction(actionNames.UPDATE_VALIDATION_RESULT, identity, createMetaRunner({
    affectedFields: affectedFieldsTypes.BY_RECORD,
    async: true
}));
export const updateAsyncValidationState = createAction(actionNames.UPDATE_ASYNC_VALIDATION_STATE, identity, createMetaRunner({
    affectedFields: affectedFieldsTypes.BY_RECORD
}));
export default ((streamBag, transmissionExtension = [])=>{
    const { formData$, singleFieldValidation$, multipleFieldValidation$, formValidation$, arrayValidationSynchronizer$, manualValidationInsert$, arrayRowValidations$, asyncValidation$, manualFocus$, fieldArrayValidation$, clearFieldsErrors$ } = streamBag;
    const transmission$ = merge(formData$.pipe(rxMap(updateFormData)), singleFieldValidation$, multipleFieldValidation$, formValidation$, arrayValidationSynchronizer$, manualValidationInsert$, arrayRowValidations$, asyncValidation$, manualFocus$, fieldArrayValidation$, clearFieldsErrors$, ...map((ext)=>ext(streamBag), transmissionExtension));
    return transmission$;
});
